export default __webpack_public_path__ + "static/media/11-58.f14504f9.jpeg";